<template>
    <div class="trending">
        <div class="trending-header">
            Top Stories
        </div>
        <div class="trending-elements-container">
            <a v-for="article in articles" :key="article.slug" class="trending-element" :href="getLink(article.slug)" @click.prevent.stop="openArticle(article.slug)">
                <div class="trending-index">
                    <intrinsic :small="article.media.thumbnail.url" ratio="square" :alt="article.media.thumbnail.alt"></intrinsic>
                </div>
                <div class="trending-title">
                    <span v-html="article.title"></span>
                    <div class="tag-slot">
                        <tags :categories="article.categories" size="small"></tags>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    import router from "./router";
    import axios from "axios";
    import Tags from "./tags.vue";
    import Intrinsic from "../shared/intrinsic.vue";

    export default {
    	components: {
			Tags,
            Intrinsic
        },
    	data () {
    	    return {
				articles: []
            }
        },
        created () {
    		if (window.__TOP_STORIES) {
				this.articles = window.__TOP_STORIES
            } else {
				axios.get('/wp-json/news/v2/top').then(response => {
					window.__TOP_STORIES = this.articles = response.data
				})
            }
        },
        methods: {
    		getLink (slug) {
				return `${window.location.origin}/article/${slug}`;
            },
    		openArticle (slug) {
    			router.push({ path: `/article/${slug}`})
            }
        }
    }
</script>

<style lang="scss">
    .tag-slot {
        margin: 5px 0;
    }

    .trending {
        background: #588041;
        overflow: auto;
        padding: .75rem;
    }

    .trending-header {
        color: #fff;
        font-size: 1.6rem;
        margin: 0.6rem 0;
        margin-bottom: 1rem;
        text-align: center;
    }
    .trending-elements-container {
        background: white;
        padding: 0 1rem;
    }
    .trending-element:last-child {
        border: none;
    }
    .trending-element {
        display: flex;
        border-bottom: solid 1px darkgray;
        padding: 1rem .5rem;
        &:hover {
            .trending-title > span {
                color: #77a95c;
            }
        }
    }

    .trending-index {
        flex: 4rem 0 0;
        font-weight: bold;
        line-height: normal;
    }

    .trending-index > img {
        box-shadow: -2px 2px 3px 1px rgba(0, 0, 0, 0.39);
    }

    .trending-title {
        padding-left: .5rem;
        font-size: 1rem;
        line-height: normal;
        color: #585858;
    }
    .trending-title > span {
        color: inherit;
    }

    .trending-title > span.notice {
        display: block;
        color: #588041;
    }
</style>


// WEBPACK FOOTER //
// trending.vue?54f82f74